import { createListenerMiddleware } from '@reduxjs/toolkit';

import type { RootState } from '../rootReducer';
import { resetSettings, settings } from './settingsSlice';
import { writeStoredSettings } from './settingsStorage';

/**
 * Persistence lives here rather than in the reducer so the reducer stays pure — a
 * `localStorage.setItem` inside it fires once per store instance in tests and makes
 * one test's appearance leak into the next.
 */
export const settingsPersistence = createListenerMiddleware();

settingsPersistence.startListening({
  matcher: (action): action is ReturnType<typeof settings> =>
    settings.match(action) || resetSettings.match(action),
  effect: (_action, api) => {
    writeStoredSettings((api.getState() as RootState).settings);
  }
});
